import { MonthGraph } from '@/pages/golf/detailSearch/_components/graphs/monthGraph'
import { RegionGraph } from '@/pages/golf/detailSearch/_components/graphs/regionGraph'
import { RootState } from '@/redux/store'
import { useSelector } from 'react-redux'

export const MainGraph = () => {
  const { monthData, monthAvgPriceByRegion } = useSelector(
    (state: RootState) => state.golfSearch.graphData,
  )

  const safeGraphData = monthData && monthData.length ? monthData : []

  const isMonthDataEmpty = safeGraphData.every((arr) =>
    arr.every((item) => item === 0),
  )

  const { regionAvgPrice } = useSelector(
    (state: RootState) => state.golfSearch.graphData,
  )

  return (
    <>
      {isMonthDataEmpty ? (
        <RegionGraph regionAvgPrice={regionAvgPrice} />
      ) : (
        <MonthGraph
          monthData={monthData}
          monthAvgPriceByRegion={monthAvgPriceByRegion}
          isDualGraph={false}
        />
      )}
    </>
  )
}
